import { AfterContentInit, Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { environment } from '@env/environment';

@Component({
  selector: 'app-token-calculator-modal',
  templateUrl: './token-calculator-modal.component.html',
  styleUrl: './token-calculator-modal.component.scss'
})
export class TokenCalculatorModalComponent implements AfterContentInit {
  constructor(public bsModalRef: BsModalRef) {
    // @ts-ignore
    window.APP_URL = environment.APP_URL;
  }

  ngAfterContentInit(): void {
    // CD-3557: load the calculator widget that cd-front-angular CI already builds
    // per environment and syncs to R2 under js-libs/, the same artifact Landing
    // includes. It used to be a copy vendored into src/assets/calculator/, which
    // had gone stale: that build still pointed i18n at the shared
    // lang.coindepo.io, so the calculator broke on dev/stage once the dApp moved
    // to a Worker and the request became cross-origin. The deployed bundles bake
    // the right per-env host (dev-lang / stage-lang / lang.coindepo.com).
    const calcBase = `${environment.staticUrl}js-libs/calculator`;
    const scripts = [
      `${calcBase}/runtime.js`,
      `${calcBase}/polyfills.js`,
      `${calcBase}/scripts.js`,
      `${calcBase}/main.js`,
    ];
    
    scripts.forEach((src) => {
      const script = document.createElement('script');
      script.src = src;
      script.type = src.endsWith('.js') && !src.includes('module') ? 'text/javascript' : 'module';
      document.body.appendChild(script);
    });

      
    const cmp = document.querySelector('coin-depo-earn-calculator');
    // @ts-ignore
    cmp.addEventListener('startEarnClicked', () => {
      document.querySelector('#BuyCoinDepoTokenNow')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      this.bsModalRef.hide();
    });
  }
}
